import clsx from 'clsx';

export const recessedSurfaceClassNames = {
    inner: {
        gray: 'surface-recessed-surface',
        orange: 'surface-recessed-surface-selected',
    },
    pocket: {
        neutral: 'surface-recessed-pocket',
        neutralPressed: 'surface-recessed-pocket-pressed',
        orange: 'surface-recessed-pocket-selected',
        orangePressed: 'surface-recessed-pocket-selected-pressed',
    },
    radius: {
        control: 'rounded-recessed-control',
        controlSm: 'rounded-recessed-control-sm',
        inner: 'rounded-recessed-surface',
        innerMd: 'rounded-recessed-surface-md',
        innerSm: 'rounded-recessed-surface-sm',
        pocket: 'rounded-recessed-pocket',
        pocketMd: 'rounded-recessed-pocket-md',
    },
} as const;

export const floatingSurfaceClassNames = {
    tone: {
        gray: 'surface-floating-gray',
        white: 'surface-floating-white',
    },
} as const;

export const floatingSurfaceItemClassNames = {
    checked: 'surface-floating-item-checked',
    highlighted: 'surface-floating-item-highlighted',
    highlightedSelected: 'surface-floating-item-highlighted-selected',
    hover: 'surface-floating-item-hover',
    selectHighlighted: 'surface-floating-item-select-highlighted',
    selected: 'surface-floating-item-selected',
} as const;

export const getTertiaryPressedSurfaceClasses = (isActive: boolean, disabled: boolean): string =>
    clsx(
        isActive ? recessedSurfaceClassNames.pocket.neutralPressed : 'bg-transparent',
        !disabled && 'hover:surface-recessed-pocket-pressed',
    );
